import callAPI from "../callApi";
import path from "../variables";

const MobileMoney = {
	initiate: (data: any) =>
		callAPI("POST", `${path.base}/payments/mobile-money/initiate`, data, "initiating mobile money payment"),
	checkStatus: (filter?: string) =>
		callAPI("GET", `${path.base}/payments/mobile-money/status${filter || ""}`, "", "checking payment status"),
	getProviders: () =>
		callAPI("GET", `${path.base}/payments/mobile-money/providers`, "", "getting payment providers"),
};

export default MobileMoney;
